import { PageType } from "@snapchat/web-blizzard-reporting";
import { ConsumerApp } from "@snapchat/web-consumer-nav";
import { generateAttributedDownloadUrl, PageFrame, ResponsiveSSRPage, Shell, } from "@snapchat/web-frame";
import { getCountryFromLocale, getDirectionForLocale, useLocale } from "@snapchat/web-i18n";
import { NoContent, Reason } from "@snapchat/web-no-content-page";
import { useGenerateWebPageViewTraceId } from "@snapchat/web-page-view";
import { useCreateOrUpdateWebClientId, useEssentialSession } from "@snapchat/web-sc-cookies";
import { incrementCountsByPageAndCountry, incrementCounter } from "@snapchat/web-graphene-reporting";
import { useEffect, useMemo, useRef } from "react";
import { grafanaBasePrefix } from "../../lib/grafana";
import { getBaseShellProps } from "../../lib/shell";
import { loadMessages } from "../../i18n/messages";
import { WWW_DOT_SNAPCHAT_DOT_COM_GA } from "@snapchat/web-analytics-types";
import { useRouter } from "next/router";
/**
 * Generic 404, content not found page.
 */
function NotFound({ disableUpsellQRCode, reason }) {
    const PAGE_NAME = "NOT_FOUND";
    const { locale, messages, changeLocale } = useLocale({
        loadMessages,
    });
    const countryRef = useRef(getCountryFromLocale(locale));
    countryRef.current = useMemo(() => getCountryFromLocale(locale), [locale]);
    const pageType = PageType.NOT_FOUND;
    useEssentialSession();
    // NOT FOUND pages are static pages and thus should be treated as requests coming from GDPR countries
    const webClientId = useCreateOrUpdateWebClientId({
        isGdpr: true,
    });
    const { traceId } = useGenerateWebPageViewTraceId();
    const router = useRouter();
    useEffect(() => {
        void incrementCountsByPageAndCountry(grafanaBasePrefix, PAGE_NAME, 1, countryRef.current);
        if (router.pathname === "/[uuid]/embed") {
            void incrementCounter(`${grafanaBasePrefix}.Embed.PageNotFound}`);
        }
    }, [router.pathname]);
    const baseShellProps = useMemo(() => getBaseShellProps(), []);
    return (<Shell isGDPRCountry locale={locale} direction={getDirectionForLocale(locale)} messages={messages} country={countryRef.current} title="Snapchat" pageMetadata={{
            pageType: PageType.NOT_FOUND,
        }} gaid={WWW_DOT_SNAPCHAT_DOT_COM_GA} webClientId={webClientId} webPageViewTraceId={traceId} {...baseShellProps}>
      <PageFrame locale={locale} localeChange={changeLocale} appType={ConsumerApp.Lens} pageType={pageType} downloadUrl={generateAttributedDownloadUrl(pageType)} webClientId={webClientId} webPageViewTraceId={traceId} disableUpsellQRCode={disableUpsellQRCode}>
        <NoContent pageType={pageType} locale={locale} changeLocale={changeLocale} reason={reason ?? Reason.CONTENT_NOT_FOUND} hideFooter // footer is rendered via pageframe.
    />
      </PageFrame>
    </Shell>);
}
function NotFoundWrapper(props) {
    return (<ResponsiveSSRPage isMobileServerSide>
      <NotFound {...props}/>
    </ResponsiveSSRPage>);
}
export { NotFoundWrapper as NotFound };
